<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocheading">Contents</h1>
<h2 class="toc_front"><a href="#/xhtml/06_Maps"><em class="italic">List of maps</em></a></h2>
<h2 class="toc_front"><a href="#/xhtml/07_Illustrations"><em class="italic">List of illustrations</em></a></h2>
<h2 class="toc_front1"><a href="#/xhtml/08_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toc_chap"><a href="#/xhtml/09_Chapter_1"><span class="toc_hang">Chapter 1:</span> Decline of the West?</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/10_Chapter_2" title="Link target outside of Sample"><span class="toc_hang">Chapter 2:</span> Law of the Jungle</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/11_Chapter_3" title="Link target outside of Sample"><span class="toc_hang">Chapter 3:</span> ‘Always Look on the Bright Side of Life’</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_4" title="Link target outside of Sample"><span class="toc_hang">Chapter 4:</span> Where did the Islamic State come from?</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/13_Chapter_5" title="Link target outside of Sample"><span class="toc_hang">Chapter 5:</span> Taking on the Islamists</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/14_Chapter_6" title="Link target outside of Sample"><span class="toc_hang">Chapter 6:</span> Dealing with Russia</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/15_Chapter_7" title="Link target outside of Sample"><span class="toc_hang">Chapter 7:</span> Wider threats to the West</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/16_Chapter_8" title="Link target outside of Sample"><span class="toc_hang">Chapter 8:</span> Future Options</span></h2>
<h2 class="toc_back1"><span href="#/xhtml/17_Conclusion" title="Link target outside of Sample"><em class="italic">Conclusion</em></span></h2>
<h2 class="toc_back"><span href="#/xhtml/18_Endnotes" title="Link target outside of Sample"><em class="italic">Endnotes</em></span></h2>
<h2 class="toc_back"><span href="#/xhtml/19_Bibliography" title="Link target outside of Sample"><em class="italic">Select Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1ed651f5